/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const browser = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M.5 4.5h15M5.75 4v10M2 14.5h12a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1Z"
    />
  </svg>
)
export default browser
